module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido8.020a67f4.svg";